module.exports = __webpack_public_path__ + "static/media/option-2.2d608b96.ogg";